/**
 * Theme System Entry Point
 * Central export for all theme-related utilities
 */

// Export tokens
export * from './tokens';
export { default as tokens } from './tokens';

// Export styling templates
export * from './stylingTemplates';
export { default as stylingTemplates } from './stylingTemplates';

// Export heatmap palette
export * from './heatmapPalette';

// Convenience exports for commonly used items
export {
  colors,
  spacing,
  borderRadius,
  shadows,
  transitions,
  transforms,
  zIndex,
} from './tokens';

export {
  cardToggleTemplate,
  actionButtonTemplate,
  inlineActionButtonTemplate,
  interactiveCardTemplate,
  dropdownTemplate,
  filterTemplate,
  applyTemplate,
  getTemplateClasses,
} from './stylingTemplates';

/**
 * Quick reference for using the theme system:
 *
 * 1. Import what you need:
 *    import { colors, cardToggleTemplate } from '@/theme';
 *    OR
 *    import { colors, cardToggleTemplate } from '../theme';
 *
 * 2. Use in your components:
 *    - For inline styles: style={{ ...cardToggleTemplate.base }}
 *    - For CSS classes: className={cardToggleTemplate.cssClasses.base}
 *    - For colors: backgroundColor: colors.primary
 *
 * 3. Apply state-based styles:
 *    const styles = applyTemplate(cardToggleTemplate, isSelected ? 'selected' : 'default');
 */